import * as Lambda from '../../services/LambdaApi';
import { paginationWrapper } from '../../utils/paginationWrapper';
import { DalilyActivity, ServiceCalendar } from '../types/Calendar';

const fetchCalendarEvents = async ({ facilityId, Filter, ResidentIds, pagingSorting, includeDowMapping = false }) => {
    const apiPath = `/s2l/${facilityId}/listAllActivitiesWithAttendees`;
    const payload = {
        Filter,
        ResidentIds,
        pagingSorting,
        ...(includeDowMapping && { includeDowMapping }),
    }
    const response = await Lambda.Post(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Content) {
        throw new Error('Error fetching calendar events');
    }
    return response.Result.Content;
}

const fetchAllCalendarEvents = async ({ facilityId, Filter, ResidentIds, includeDowMapping = false }) => {
    return await paginationWrapper(
        {
            apiCall: fetchCalendarEvents,
            params: {
                facilityId,
                Filter,
                ResidentIds,
                ...(includeDowMapping && { includeDowMapping }),
            },
        }
    ) as  ServiceCalendar[] | DalilyActivity[];
}

const fetchAllResidentCalendarEvents = async ({ facilityId, Filter }) => {
    const payload = {
        Filter
    }
    const apiPath = `/s2l/${facilityId}/listResidentCalendar`;
    const response = await Lambda.Post(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Content) {
        throw new Error('Error fetching resident calendar events');
    }
    return response.Result.Content;
};

const createCalendarEvent = async ({ facilityId, event }) => {
    const apiPath = `/s2l/${facilityId}/createResidentCalendar`;
    const response = await Lambda.Post(apiPath, event, 'lambda');
    if (!response || !response.Result || !response.Result.Content) {
        throw new Error('Error creating calendar event');
    }
    return response.Result.Success;
}

const updateCalendarEvent = async ({ facilityId, event }) => {
    const apiPath = `/s2l/${facilityId}/updateResidentCalendar`;
    const response = await Lambda.Post(apiPath, event, 'lambda');
    if (!response || !response.Result) {
        throw new Error(response?.Result?.Error || 'Error updating calendar event');
    }
    if (response.Result.Success === false) {
        throw new Error(response.Result.Error || 'Error updating calendar event');
    }
    return response.Result.Success ?? response.Result.Content;
}

const deleteCalendarEvent = async ({ facilityId, payload }) => {
    const apiPath = `/s2l/${facilityId}/deleteResidentCalendar`;
    const response = await Lambda.Post(apiPath, payload, 'lambda');
    if (!response || !response.Result) {
        throw new Error(response?.Result?.Error || 'Error deleting calendar event');
    }
    if (response.Result.Success === false) {
        throw new Error(response.Result.Error || 'Error deleting calendar event');
    }
    return response.Result.Success ?? response.Result.Content;
}

const changeServiceActivityAttendingStatus = async ({ facilityId, payload }) => {
    const apiPath = `/s2l/${facilityId}/serviceInstanceAttendees`;
    const response = await Lambda.Post(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Content) {
        throw new Error(response.Result.Error ? response.Result.Error : 'Error changing attending status');
    }
    return response.Result;
}

const updateServiceActivityAttendance = async ({ facilityId, payload }) => {
    const apiPath = `/s2l/${facilityId}/updateServiceInstanceAttendees`;
    const response = await Lambda.Put(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Success) {
        throw new Error('Error changing attending status');
    }
    return response.Result;
}

const changeNormalActivityAttendingStatus = async ({ facilityId, payload }) => {
    const apiPath = `/s2l/${facilityId}/attendees`;
    const response = await Lambda.Post(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Content) {
        throw new Error('Error changing attending status');
    }
    return response.Result;
}

const deleteServiceInstanceAttendee = async ({ facilityId, payload }) => {
    const apiPath = `/s2l/${facilityId}/deleteServiceInstanceAttendees`;
    const response = await Lambda.Put(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Success) {
        throw new Error('Error deleting service instance attendee');
    }
    return response.Result;
}

const deleteActivityAttendee = async ({ facilityId, payload }) => {
    const apiPath = `/s2l/${facilityId}/deleteActivityAttendee`;
    const response = await Lambda.Post(apiPath, payload, 'lambda');
    if (!response || !response.Result || !response.Result.Success) {
        throw new Error('Error deleting activity attendee');
    }
    return response.Result;
}

const fetchActivityAttendeeById = async (facilityId, attendingId, registrantId) => {
    const apiPath = `/s2l/${facilityId}/fetchActivityAttendee`;
    const params = { activityId: attendingId, registrantId };
    const response = await Lambda.Post(apiPath, params, 'lambda');
    if (!response || !response.Result || !response.Result.Content) {
        throw new Error('Error fetching activity attendee');
    }
    return response.Result.Content;
}

export { fetchAllCalendarEvents , fetchAllResidentCalendarEvents, createCalendarEvent, updateCalendarEvent, deleteCalendarEvent, changeServiceActivityAttendingStatus, changeNormalActivityAttendingStatus, updateServiceActivityAttendance, deleteServiceInstanceAttendee, deleteActivityAttendee, fetchActivityAttendeeById };